export default function cxUsers(fetch, baseUrl) {
  return {
    getAllUsers() {
      return fetch.get(baseUrl);
    }
  };
}
